// export const HOSTNAME = '127.0.0.1:3001';
export const HOSTNAME = '192.168.99.100:3001';
// The above line should be uncommented and replaced with the 
// docker-machine ip on windows computers
